import React from 'react';

// Icons
import { FaLinkedinIn } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';
import { FaTelegramPlane } from 'react-icons/fa';

// Images
import Mypic from '../Assets/img/mypic.png';
import hy from '../Assets/emojis/hy.png';

const Hero = () => {
  return (
    <>
      <div className="heroContainer">
        <div className="upperHeroContent">
          {/* My Profile Picture */}
          <div className="mypicContainer">
            <img src={Mypic} alt="mypic" className="mypic" />
          </div>

          {/* Headlines */}
          <div className="headlineContainer">
            <h1 className="headline">
              Full-Stack Web
              <br /> Developer
              <img
                src={hy}
                alt="hy"
                width="40"
                style={{ paddingLeft: '5px' }}
              />
            </h1>

            <p className="subHeadline">
              Hi, I'm Amanuel Abera, a Full-Stack Web Developer building SaaS
              platforms, AI-powered applications, and real-time systems.🌐
            </p>

            <div className="connects">
              <a
                href="https://linkedin.com/in/amanuel-abera-kedida"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn className="connectIcon" />
              </a>
              <a
                href="https://github.com/ProgrammingInsider"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGithub className="connectIcon" />
              </a>
              <a
                href="https://youtube.com/@ProgrammingInsider"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube className="connectIcon" />
              </a>
              <a
                href="https://t.me/Aman_A2208"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTelegramPlane className="connectIcon" />
              </a>
            </div>
            <div className="btnContainer">
              <a href="#Contact" className="primaryBtn">
                Let's Connect
              </a>
              <a
                href="https://drive.google.com/file/d/1XIENcvUVY3Z-4UbmVAgAyHPnmiB9o5E8/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className="secondaryBtn"
              >
                Download CV
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
